<template>
  <div class="profile">
    <!--    <div class="profile-head" @click="$router.push('/user/myInfoChange')">-->
    <div class="profile-head" @click="$router.push('/user/userInfo')">
      <div class="profile-head-info">
        <img :src="userInfo.avatar || avatar" />
        <div class="personal-info">
          <div>
            <div class="profile-name-wrap">
              <p class="profile-name">{{ userInfo.name || userInfo.id }}</p>
              <!--              <span-->
              <!--                class="profile-active"-->
              <!--                @click.stop="activeButton"-->
              <!--                v-if="!userInfo.active"-->
              <!--                >激活</span-->
              <!--              >-->
            </div>
            <p class="profile-intro">{{ userInfo.phone | encodePhone }}</p>
          </div>
        </div>
      </div>
      <Icon
        class="profile-head-icon"
        style="color: #AED5FE;"
        type="iconb"
      ></Icon>
    </div>
    <div class="profile-body">
      <!--      <div-->
      <!--        class="profile-body-item"-->
      <!--        @click="$router.push('/profile/creditCard')"-->
      <!--      >-->
      <!--        <div class="item-left">-->
      <!--          <Icon class="item-icon-left" type="iconxingzhuang3" />身份认证-->
      <!--        </div>-->
      <!--        <Icon class="profile-body-item-icon" type="iconb"></Icon>-->
      <!--      </div>-->
<!--      <div-->
<!--        class="profile-body-item"-->
<!--        @click="$router.push('/bankCard/bankCard')"-->
<!--      >-->
<!--        <div class="item-left">-->
<!--          <Icon class="item-icon-left" type="iconxingzhuang2" />银行卡-->
<!--        </div>-->
<!--        <Icon class="profile-body-item-icon" type="iconb"></Icon>-->
<!--      </div>-->
      <div class="profile-body-item" @click="$router.push('/ship/shipList')">
        <div class="item-left">
          <Icon class="item-icon-left" type="iconxingzhuang5" />我的渔船
        </div>
        <Icon class="profile-body-item-icon" type="iconb"></Icon>
      </div>

      <div class="profile-body-item" @click="goCompanyList">
        <div class="item-left">
          <Icon class="item-icon-left" type="iconcompany" />我的公司
        </div>
        <Icon class="profile-body-item-icon" type="iconb"></Icon>
      </div>
      <!--      <div class="profile-body-item" @click="myOut" v-if="showLogOut">-->
      <!--        <div class="item-left">-->
      <!--          <Icon class="item-icon-left" type="iconxingzhuang6" />退出-->
      <!--        </div>-->
      <!--        <Icon class="profile-body-item-icon" type="iconb"></Icon>-->
      <!--      </div>-->
      <div class="profile-body-item" @click="goNoticeCenter">
        <div class="item-left">
          <img class="iconImg" src="../../assets/tongzhi.svg">
          通知中心
        </div>
        <Icon class="profile-body-item-icon" type="iconb"></Icon>
      </div>
      <div class="profile-body-item" @click="goPicture">
        <div class="item-left">
            <img class="iconImg" src="../../assets/pictures.png">
            证照信息
        </div>
        <Icon class="profile-body-item-icon" type="iconb"></Icon>
      </div>
      <div class="profile-body-item" @click="openYinsi">
        <div class="item-left">
          <img class="iconImg" src="../../assets/yinsi.svg">
          隐私协议
        </div>
        <Icon class="profile-body-item-icon" type="iconb"></Icon>
      </div>

      <div class="profile-body-item" v-if="admin == true" @click="goAdmin">
        <div class="item-left">
          切换业务员端
        </div>
        <Icon class="profile-body-item-icon" type="iconb"></Icon>
      </div>
    </div>
    <div class="version">v1.15</div>
    <active ref="activeBox"></active>
    <confirm v-model="show2" title="操作提示" @on-confirm="onConfirm">
      <p style="text-align:center;">是否认证？</p>
    </confirm>
  </div>
</template>

<script>
import avatar from "@/assets/head@2x.png";
import { mapActions, mapMutations } from "vuex";
import Active from "../acitve/active";
import { clientTowFactor } from "../../api/module/api-client";
import { getClientDetail } from "../../api/client";
import { clear } from "../../utils/auth";
import { userIss } from "../../api/auth";

export default {
  components: {
    Active
  },
  data() {
    return {
      avatar,
      // debug: process.env.NODE_ENV === "development",
      show: false,
      show2: false,
      showLogOut: true,
      admin: false
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  created() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("hsx_") > 0) {
      this.showLogOut = false;
    } else {
      this.showLogOut = true;
    }
    userIss()
      .then(res => {
        if (res) {
          this.admin = true;
        }
      })
      .catch(err => {
        this.$showError(err);
      });
  },
  mounted() {},
  filters: {
    encodePhone(phone) {
      if (phone) {
        return phone.slice(0, 3) + "*".repeat(4) + phone.slice(3 + 4);
      }
    }
  },
  methods: {
    openYinsi(){
      window.location.href='https://app.haishangxian.net/app/newPolicyService.html'
    },
    goPicture(){
      this.$router.push({ path: "/user/pictures" });
    },
    goNoticeCenter() {
      this.$router.push({ path: "/user/noticeCenter" });
    },
    goAdmin() {
      this.$vux.loading.show();
      this.login({ grant_type: "user2admin" })
        .then(res => {
          this.$vux.loading.hide();
          this.$router.replace({ path: "/salesman/index" });
        })
        .catch(err => {
          this.$vux.loading.hide();
          this.$showError(err);
        });
    },
    goCompanyList() {
      this.$router.push({ path: "/company/companyList" });
    },
    onConfirm() {
      this.$vux.loading.show();
      clientTowFactor({})
        .then(() => {
          getClientDetail().then(res => {
            this.$store.commit("saveUserInfo", res);
            this.$vux.loading.hide();
            this.show2 = false;
            this.$showMessage("认证成功");
          });
        })
        .catch(() => {
          this.$vux.loading.hide();
          this.show2 = false;
          this.$showMessage("认证失败");
        });
    },
    activeButton() {
      this.$refs.activeBox.showBox = true;
    },
    ...mapActions(["logout", "login"]),
    ...mapMutations(["CLEAR_ROLE"]),
    myOut() {
      let a = confirm("确定吗？");
      if (a) {
        this.handleLogout();
      } else {
        return false;
      }
    },
    handleLogout() {
      this.logout();
      this.CLEAR_ROLE();
      clear();
      this.$navigation.cleanRoutes();
      this.$router.push({ name: "Login" });
    }
  }
};
</script>

<style lang="less" scoped>
  .version{
      position: absolute;
      left: 50%;
      bottom: 110px;
      z-index: 11;
      width: 50px;
      text-align: center;
      color: #cccccc;
      margin-left: -25px;
      font-size: 14px;
  }
  .iconImg{
    width: 46px;
    height: 46px;
    display: inline-block;
    margin-right: 30px;
    float: left;
  }
.profile {
  padding: 20px 30px 0;
  &-name {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  &-name-wrap {
    display: flex;
    align-items: center;
  }
  &-active {
    margin-left: 18px;
    background: rgba(3, 28, 59, 1);
    height: 1.5em;
    width: 4em;
    border-radius: 15px;
    text-align: center;
    line-height: 1.5em;
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  &-intro {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
  &-head {
    width: 100%;
    height: 230px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 1);
    background-image: url("~@/assets/profile.png");
    box-shadow: 0 0 15px 0 rgba(56, 142, 255, 0.08);
    border-radius: 10px;
    box-sizing: border-box;
    justify-content: space-between;
  }
  &-head-info {
    display: flex;
    position: relative;
    left: 0;
    bottom: 0;
    img {
      height: 128px;
      width: 128px;
      border-radius: 50%;
    }
  }
  &-head-icon {
    font-size: 19px;
    color: rgba(174, 213, 254, 1);
  }
  .personal-info {
    margin-left: 30px;
    display: flex;
    align-items: center;
  }
  &-body-item {
    height: 100px;
    background: rgba(255, 255, 255, 1);
    border-radius: 14px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(27, 27, 27, 1);
    &-icon {
      color: #e2e2e2;
    }
  }
  .item-left {
    display: flex;
    align-items: center;
  }
  .item-icon-left {
    font-size: 23px;
    margin-right: 30px;
  }
}
.qianyue {
  font-size: 12px;
  text-align: center;
  color: #fff;
  background: #1a1a1a;
  border-radius: 20px;
  padding: 10px 20px;
}
</style>
